import { render, staticRenderFns } from "./NumberInputColor.vue?vue&type=template&id=2a8436ef&"
import script from "./NumberInputColor.vue?vue&type=script&lang=js&"
export * from "./NumberInputColor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports